// extracted by mini-css-extract-plugin
module.exports = {"name":"ArticleSnippet_name_3-Dz1","text":"ArticleSnippet_text_3LHNl"};